import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { LESTE_TOKEN } from '../../../constants/storage';
import { setInitialUrl } from '../../authentication/helpers';

export const useHistoryInterceptor = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  // Update initial URL on every location update
  useEffect(() => {
    const { redirectUrl } = window.nortada.keycloakAuthentication;

    setInitialUrl(redirectUrl, `${history.location.pathname}${history.location.search}`);
  }, [history.location.pathname, history.location.search]);

  // Remove Leste token when user exit Editor
  useEffect(() => {
    if (localStorage.getItem(LESTE_TOKEN)) {
      localStorage.removeItem(LESTE_TOKEN);
    }
  }, [history.location.pathname]);

  // Remove last slash from URL (except if slash is the only element of the path)
  useEffect(() => {
    if (pathname !== '/' && pathname[pathname.length - 1] === '/') {
      history.push(pathname.slice(0, -1));
      window.location.reload();
    }
  }, [pathname, history]);
};
